var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box",class:("color-" + _vm.type)},[_c('font-awesome-icon',{attrs:{"icon":['fal', 'circle-info'],"size":"xl"}}),_c('p',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }